import Controller from '@ember/controller';
import { service } from '@ember/service';
import dateUtils from 'donor-elf-web/lib/date-utils';
import FundsService from 'donor-elf-web/services/funds-service';
import type { DashboardRouteModel } from 'donor-elf-web/routes/funds/fund/dashboard';
import type { GoalDataTotalAndExpecting } from 'donor-elf-web/models/goal';
import moment from 'moment';

export default class DashboardTotalAndExpectingController extends Controller {
  @service declare fundsService: FundsService;

  model!: DashboardRouteModel;

  get goal() {
    return this.model.goal;
  }
  get goalData(): GoalDataTotalAndExpecting {
    return this.model.goal?.goalData as GoalDataTotalAndExpecting;
  }

  get timeLeftToRaiseLabel() {
    let goalDate = dateUtils.deserializeDateOnly(this.goalData.goal_date);
    let duration = moment.duration(moment().diff(goalDate));
    let label = null;
    if (Math.abs(duration.asMonths()) >= 2) {
      label = `${Math.abs(Math.round(duration.asMonths()))} months`;
    } else if (Math.abs(duration.asWeeks()) >= 2) {
      label = `${Math.abs(Math.round(duration.asWeeks()))} weeks`;
    } else {
      label = `${Math.abs(Math.round(duration.asDays()))} days`;
    }
    if (duration.asDays() < 0) {
      label = `${label} left`;
    } else {
      label = `${label} overdue`;
    }
    return label;
  }
}
